import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en.ts';
import { sv } from './sv.ts';

export type Lang = 'sv' | 'en';

function initialLang(): Lang {
  try {
    const saved = localStorage.getItem('lang');
    if (saved === 'sv' || saved === 'en') return saved;
  } catch {
    // Storage can be unavailable (private mode); fall back to Swedish.
  }
  return 'sv';
}

void i18n.use(initReactI18next).init({
  resources: { sv: { translation: sv }, en: { translation: en } },
  lng: initialLang(),
  fallbackLng: 'sv',
  interpolation: { escapeValue: false },
});

export function setLang(lang: Lang) {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem('lang', lang);
  } catch {
    // Not critical.
  }
}

export const locale = () => (i18n.language === 'en' ? 'en-GB' : 'sv-SE');

export default i18n;
